window.LAZZA_DELIVERY_ZIPS = [
  // Hauts-de-Seine (92)
  "92000",
  "92100",
  "92110",
  "92130",
  "92150",
  "92170",
  "92200",
  "92210",
  "92300",
  "92310",
  "92370",
  "92380",
  "92400",
  "92410",
  "92420",
  "92430",
  "92500",
  "92800",

  // Yvelines (78)
  "78000",
  "78140",
  "78150",
  "78170",
  "78180",
  "78190",
  "78210",
  "78220",
  "78280",
  "78310",
  "78330",
  "78350",
  "78370",
  "78430",
  "78450",
  "78530",
  "78960",

  // Paris
  "75006",
  "75007",
  "75008",
  "75015",
  "75016",
  "75017",
  
  // Essonne
  "91120",
  "91160",
  "91170",
  "91190",
  "91200",
  "91300",
  "91310",
  "91320",
  "91380",
  "91400",
  "91570",
  "91940",
];